// src/components/DashboardGrid.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import '../assets/styles/DashboardGrid.css';

const DashboardGrid = () => {
  const tiles = [
    { path: '/awesomemedia', label: 'Media', className: 'media' },
    { path: '/pwnedmachines', label: 'Pwned Machines', className: 'pwned' },
    { path: '/projects', label: 'Projects', className: 'projects' },
    { path: '/recentactivity', label: 'Recent Activity', className: 'recentactivity' },
    { path: '/thoughts', label: 'Thoughts', className: 'thoughts' },
    { path: '/toolbox', label: 'Toolbox', className: 'toolbox' },
    { path: '/websiteupdates', label: 'Website Updates', className: 'updates' },
  ];

  // Purely sort in-memory before rendering
  const sortedTiles = [...tiles].sort((a, b) =>
    a.label.localeCompare(b.label, undefined, { sensitivity: 'base' })
  );

  return (
    <div className="dashboard-grid">
      {sortedTiles.map((tile) => (
        <Link
          key={tile.path}
          to={tile.path}
          className={`dashboard-tile ${tile.className}`}
        >
          <h3>{tile.label}</h3>
        </Link>
      ))}
    </div>
  );
};

export default DashboardGrid;